// The Call button opens Spruce's contact search on the patient's number (spec
// 2026-10-13-spruce-integration §3.4). The path is the one Spruce's own "See all contacts"
// opens, read from its web app — undocumented, so a change there lands on Spruce's home page.

export const SPRUCE_APP_ORIGIN = 'https://app.sprucehealth.com';

const ORG_ID = /^entity_[A-Za-z0-9]+$/;

export function spruceOrgId(raw: string | null | undefined): string | null {
  const v = String(raw ?? '').trim();
  return ORG_ID.test(v) ? v : null;
}

// A real US (NANP) number as 10 digits; anything else is not something Spruce can call.
export function usTenDigits(phone: string | null | undefined): string | null {
  const d = String(phone ?? '').replace(/\D/g, '');
  let ten = '';
  if (d.length === 11 && d.startsWith('1')) ten = d.slice(1);
  else if (d.length === 10) ten = d;
  return /^[2-9]\d{2}[2-9]\d{6}$/.test(ten) ? ten : null;
}

export function spruceContactSearchUrl(
  orgId: string | null | undefined,
  phone: string | null | undefined,
): string | null {
  const org = spruceOrgId(orgId);
  const ten = usTenDigits(phone);
  if (!org || !ten) return null;
  const url = new URL(`/org/${org}/contacts/search`, SPRUCE_APP_ORIGIN);
  url.searchParams.set('search', ten);
  return url.origin === SPRUCE_APP_ORIGIN ? url.toString() : null;
}

// A copy of scripts/spruce-rows.mjs's SPRUCE_REF_RE: this module stays import-free (config/constants.ts reads it).
const PAYLOAD_REF = /^spruce:(entity_[A-Za-z0-9]+):(t_[A-Za-z0-9]+):(ti_[A-Za-z0-9]+)$/;

// The conversation in Spruce's web app, only for a row of our own clinic's org (never the org the row names alone).
export function spruceThreadUrl(
  configuredOrg: string | null | undefined,
  payloadRef: string | null | undefined,
): string | null {
  const org = spruceOrgId(configuredOrg);
  const m = PAYLOAD_REF.exec(String(payloadRef ?? ''));
  if (!org || !m || m[1] !== org) return null;
  const url = new URL(`/org/${encodeURIComponent(org)}/thread/${encodeURIComponent(m[2]!)}`, SPRUCE_APP_ORIGIN);
  return url.origin === SPRUCE_APP_ORIGIN ? url.toString() : null;
}
